interface Configuration {
  environment: "local" | "int" | "prod";
  apiRootUrl: string;
  appInsightsInstrumentationKey: string;
  googleAnalyticsMeasurementId: string;
  webRootUrl: string;
  coherenceSurveyGuid: string;
  chatkitWorkflowId: string;
}

const defaultConfiguration: Configuration = {
  environment: "local",
  apiRootUrl: "https://localhost:7071",
  appInsightsInstrumentationKey: "9c9b4e31-b656-48b1-ab32-6438ad4d0e13",
  googleAnalyticsMeasurementId: "G-DN492CM8TM",
  webRootUrl: "http://localhost:3000",
  coherenceSurveyGuid: "7d2e3362-2f75-420a-854d-19627e269d89",
  chatkitWorkflowId: "wf_6943203fee1c8190ae8e5e3044096c5f05fd0d8c3a825f7b",
};

const configuration: Configuration = {
  ...defaultConfiguration,
  ...(window as any).CHRYSALIS_CONFIG,
};

export { configuration };
